import { Component } from '@angular/core';
import { IStatsTileDefinition } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/dashboards/interfaces/tiles/definitions/stats-tile-definition.interface';
import { FilterConditionType } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/interfaces/filters/filter-condition-type.enum';
import { FilterOperatorType } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/interfaces/filters/filter-operator-type.enum';

@Component({
  selector: 'app-overview-report',
  template: `<suvo-bi-tile-wrapper class="dashboard-tile" [tileInstance]="tileInstance" />`,
})
export class OverviewReportComponent {
  readonly tileInstance: IStatsTileDefinition = {
    tileType: 'stats',
    title: 'Overview',
    statDefinitions: [
      {
        title: 'Total unsubmitted samples in system',
        recipe: {
          dataSource: 'samples',
          fullRoute: 'sample-reports',
          metric: 'count',
          filters: {
            name: 'Report Filters',
            query: {
              op: FilterOperatorType.And,
              rules: [
                {
                  key: 'submittedAt',
                  con: [
                    {
                      type: FilterConditionType.NotExists,
                    },
                  ],
                },
              ],
            },
          },
        },
      },
      {
        title: 'Total unfinalised tows in system',
        recipe: {
          dataSource: 'tows',
          fullRoute: 'recording-event-reports',
          metric: 'count',
          extraParams: {
            type: 'tow',
          },
          filters: {
            name: 'Report Filters',
            query: {
              op: FilterOperatorType.And,
              rules: [
                {
                  key: 'metadata.finalisedAt',
                  con: [
                    {
                      type: FilterConditionType.NotExists,
                    },
                  ],
                },
              ],
            },
          },
        },
      },
    ],
    canView: true,
    backgroundColor: 'white',
  };
}
